import { Navigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useCurrentUser } from "../hooks/useAuth.js";

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return null;
  }

  if (user === null) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
}
